import accessors from '../accessors';

const canBeMoved = (element) => Boolean(accessors.getMoveConstraintForElement(element));

export default canBeMoved;
